export const environment = {
  production: true,
  apiUrl: 'https://docin-back.cracss.com/api'
};



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/environments/environment.ts